import create from 'zustand';
import * as Sentry from '@sentry/browser';
import { AxiosError } from 'axios';
import { useAuthStore } from './auth-store';
import { KitRegistrationService } from '../services/kit-registration/service';

interface KitRegistrationState {
  slug: string;
  error: AxiosError | unknown;
  isKitRegistered: boolean;
  registerKit: { (): Promise<void> };
}

const kitRegistrationService = new KitRegistrationService();
const initialSlug = 'retail';

export const useKitRegistrationStore = create<KitRegistrationState>((set) => ({
  slug: initialSlug,
  error: null,
  isKitRegistered: false,
  registerKit: async () => {
    const { id, accessToken } = useAuthStore.getState();
    const uniqueId = sessionStorage.getItem('uniqueId') || '';
    if (!accessToken) {
      return;
    }
    try {
      await kitRegistrationService.registerKit({
        userId: id,
        uniqueId,
        accessToken,
      });
      set(() => ({ isKitRegistered: true }));
      return;
    } catch (error) {
      Sentry.captureException(error);
      set(() => ({ error }));
      throw error;
    }
  },
}));
